<div class="card">
  <div
    class="card-body d-flex align-items-center justify-content-between flex-wrap"
    style="gap: 1rem"
  >
    <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
      <h2 class="m-0 mr-2">Roles</h2>
      <small class="title-description"> Gestion de los roles </small>
    </div>
    <div class="d-flex align-items-center gap-0">
      <button
        mat-icon-button
        (click)="resetForm()"
        *ngIf="selectedRole != undefined"
      >
        <mat-icon>add_circle_outline</mat-icon>
      </button>
      <button mat-icon-button (click)="getAllRoles()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</div>
<form class="card mt-3" [formGroup]="form">
  <div
    class="card-header d-flex align-items-center justify-content-between flex-wrap"
    style="gap: 1rem"
  >
    <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
      <h2 class="m-0 mr-2">
        {{
          selectedRole && selectedRole.codigo_rol
            ? selectedRole.codigo_rol
            : "Crear"
        }}
      </h2>
      <small class="title-description">
        {{
          selectedRole && selectedRole.descripcion_rol
            ? selectedRole.descripcion_rol
            : "Digite todos los campos"
        }}
      </small>
    </div>
  </div>
  <div class="card-body row">
    <mat-form-field appearance="fill" class="col-12 col-md-6">
      <mat-label>Nombre</mat-label>
      <input
        matInput
        formControlName="descripcion_rol"
        (input)="
          form
            .get('descripcion_rol')
            ?.setValue(form.get('descripcion_rol')?.value.toUpperCase())
        "
        type="text"
        [maxlength]="100"
      />
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-12 col-md-6">
      <mat-label>Estado</mat-label>
      <mat-select formControlName="estado">
        <mat-option [value]="'S'">Activo</mat-option>
        <mat-option [value]="'I'">Inactivo</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="card-footer d-flex align-items-center justify-content-end gap-2">
    <button
      mat-flat-button
      class="btn btn-secondary"
      type="button"
      *ngIf="selectedRole != undefined"
      (click)="modify()"
      [ngClass]="{ 'btn-primary': selectedRole == undefined }"
    >
      Modificar
    </button>
    <button
      mat-flat-button
      type="button"
      (click)="create()"
      class="btn btn-primary"
    >
      Crear nuevo
    </button>
  </div>
</form>

<div class="shadow mt-3">
  <coky-table
    [title]="'Listado de roles'"
    [description]="'seleccione un registro para modificar / asignar opciones'"
    [data]="roles"
    (clickRow)="setSelectedRole($event)"
    [multipleSelection]="false"
  >
  </coky-table>
</div>

<!-- Si el rol fue selecciondado y hay opciones disponibles, permite seleccionarlas -->
<!-- Opciones disponibles -->
<div class="shadow mt-3">
  <coky-table
    [title]="
      'Asignar opciones al rol ' + (selectedRole ? selectedRole.codigo_rol : '')
    "
    [description]="'seleccione las opciones que desea asignar a este rol'"
    [data]="options"
    (clickRow)="selectOptionToAssign($event)"
    [multipleSelection]="true"
  >
  </coky-table>
</div>
<!-- Opciones seleccionadas -->
<div class="card mt-3">
  <div
    class="card-body d-flex align-items-center justify-content-between flex-wrap"
    style="gap: 1rem"
  >
    <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
      <h2 class="m-0 mr-2">Opciones para asignar</h2>
      <small class="title-description">
        {{ selectedOptions.length }}
      </small>
    </div>
    <div
      class="d-flex align-items-center justify-content-end gap-2"
      *ngIf="selectedOptions.length > 0"
    >
      <button
        mat-flat-button
        type="button"
        class="btn"
        (click)="asignarOpciones()"
      >
        Asignar
      </button>
    </div>
  </div>
</div>

<!-- Si el rol fue seleccionado, aparece la lista de opciones que tiene asignadas -->
<!-- Opciones del rol -->
<div class="shadow mt-3">
  <coky-table
    [title]="
      'Opciones del rol ' + (selectedRole ? selectedRole.codigo_rol : '')
    "
    [description]="'seleccione las opciones que desea eliminar'"
    [data]="obtionsByRole"
    (clickRow)="selectOptionsToDelete($event)"
    [multipleSelection]="true"
  >
  </coky-table>
</div>

<!-- Opciones para eliminar -->
<div class="card mt-3">
  <div
    class="card-body d-flex align-items-center justify-content-between flex-wrap"
    style="gap: 1rem"
  >
    <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
      <h2 class="m-0 mr-2">Opciones a eliminar</h2>
      <small class="title-description">
        {{ selectedOptionsToDelete.length }}
      </small>
    </div>
    <div
      class="d-flex align-items-center justify-content-end gap-2"
      *ngIf="selectedOptionsToDelete.length > 0"
    >
      <button
        mat-flat-button
        type="button"
        class="btn"
        (click)="eliminarOpciones()"
      >
        Eliminar
      </button>
    </div>
  </div>
</div>
